
import { Options, Vue } from "vue-class-component";
import TagSelect from "./components/TagSelect.vue";
import Language from "./components/Language.vue";
import GuestCard from "./components/GuestCard.vue";
import SortByMenu from "./components/SortByMenu.vue";
import SharePopup from "./components/SharePopup.vue";
import AlphabetMenu from "./components/AlphabetMenu.vue";
import SearchBar from "./components/SearchBar.vue";
import Button from "./components/Button.vue";
import ButtonShare from "./components/ButtonShare.vue";
import DayMenuButtons from "./components/DayMenuButtons.vue";
import ScheduleDayMenuButtons from "./components/ScheduleDayMenuButtons.vue";
import TagContainer from "./components/TagContainer.vue";
import EventGuestTitleBar from "./components/EventGuestTitleBar.vue";
import Copyrights from "./components/Copyrights.vue";
import EventSchedule from "./components/EventSchedule.vue";
import Contact from "./components/Contact.vue";
import ContactLeft from "./components/ContactLeft.vue";
import GuestLinkCards from "./components/GuestLinkCards.vue";
import SocialMediaButtons from "./components/SocialMediaButtons.vue";
import MainHeaderSortMenu from "./components/MainHeaderSortMenu.vue";
import SeparatorBar from "./components/SeparatorBar.vue";
import ScheduleCardByPlace from "./components/ScheduleCardByPlace.vue";
import ScheduleCardByHour from "./components/ScheduleCardByHour.vue";
import ScheduleByHourGrid from "./components/ScheduleByHourGrid.vue";
import ScheduleByPlaceGrid from "./components/ScheduleByPlaceGrid.vue";
import EventGuestHeader from "./components/EventGuestHeader.vue";
import MainHeader from "./components/MainHeader.vue";
import EventGuestImage from "./components/EventGuestImage.vue";
import TextField from "./components/TextField.vue";
import Select from "./components/Select.vue";
// @ts-ignore
import PreLoader from "./components/PreLoader.vue";
// @ts-ignore

@Options({
  components: {
    TagSelect,
    GuestCard,
    Language,
    AlphabetMenu,
    SharePopup,
    SortByMenu,
    SearchBar,
    Button,
    ButtonShare,
    DayMenuButtons,
    ScheduleDayMenuButtons,
    TagContainer,
    EventGuestTitleBar,
    Copyrights,
    EventSchedule,
    Contact,
    ContactLeft,
    GuestLinkCards,
    SocialMediaButtons,
    MainHeaderSortMenu,
    SeparatorBar,
    ScheduleCardByPlace,
    ScheduleCardByHour,
    ScheduleByHourGrid,
    ScheduleByPlaceGrid,
    EventGuestHeader,
    MainHeader,
    EventGuestImage,
    TextField,
    Select,
    PreLoader,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      popup: false,
    };
  },
  methods: {
    togglePopup() {
      return !this.popup
        ? ((this.popup = true), this.$refs.sharepopup.focus())
        : (this.popup = false);
    },
    closePopup() {
      return (this.popup = false);
    },
  },
})
export default class App extends Vue {
  guestCard = {
    name: "Meowsie",
    date: "wednesday 12",
    hour: "12h30 - 1h00",
    place: "Place Plum",
    image: "/img/meowsie.jpg",
  };
  categoryMain = ["artists", "a - z", "by day"];
  categorySchedule = ["par lieu", "par heure"];
  button = {
    mainColor: "purple",
    hoverColor: "blue",
    text: "accueil",
    link: "link",
  };
  btnShareText = "partager";
  btnDay = [
    "monday 1",
    "tuesday 2",
    "wednesday 3",
    "thursday 4",
    "friday 6",
    "saturday 7",
    "sunday 8",
  ];
  tagText = ["rock", "synthpop", "music"];
  eventGuestTitleBar = {
    eventTitle: "Awesome Event",
    country: "Aruba",
  };
  copyright = "This person.";
  eventSchedule = {
    date: "dimanche 23 octobre",
    hour: "12h00 - 13h00",
    place: "Scène La Roche",
    link: "#",
    name: "Super event",
  };
  contact = {
    telephone: "12 345 6789",
    email: "person@thisaddress.com",
    website: "http://thissite.com",
  };
  sortedDays = ["monday", "tuesday"];
  guestData = [
    {
      name: "Meowsie",
      image: "z5f5740cf8a935e28c0e8b4f7.jpg",
    },
    {
      name: "Cool Katt",
      image: "z5f5740cf8a935e28c0e8b4f7.jpg",
    },
  ];
  socialMedia = {
    instagram: "#",
    twitter: "#",
    facebook: "#",
    deezer: "#",
    soundcloud: "#",
    youtube: "#",
    spotify: "#",
  };
  separatorText = "Scène Royale";
  scheduleCardByPlace = {
    hour: "12h00",
    event: "Chouquette Royal",
    image: "5f5788b28a935e28c0e8b55e",
  };
  scheduleCardByHour = {
    name: "This event",
    hour: "12h00",
    place: "La Plage",
    image: "5f5788b28a935e28c0e8b55e",
    id: "123",
    link: "querty",
  };
  scheduleByHour = [
    {
      place: "La Plage",
      hour: 1647484200000,
      title: "Chouquette Royal",
      id: "id",
      image: "5f5788b28a935e28c0e8b55e",
    },
    {
      place: "La Plage",
      hour: "12h00",
      title: "Croissant Magnifique",
      image: "5f5788b28a935e28c0e8b55e",
      id: "id",
    },
    {
      place: "La Plage",
      hour: "12h00",
      title: "Tartelette Fabuleuse",
      image: "5f5788b28a935e28c0e8b55e",
      id: "id",
    },
    {
      place: "La Plage",
      hour: "12h00",
      title: "Macaron Melon",
      image: "5f5788b28a935e28c0e8b55e",
      id: "id",
    },
  ];
  guestTypes = ["artist", "librarian", "carnie"];
  programs = ["Festival 🎸", "Village 🏠", "Concerts Gratuits"];
  eventGuestImage = {
    title: "Meowsie",
    image: "5f5788b28a935e28c0e8b55e",
  };
  text = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do 
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
          in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
          officia deserunt mollit anim id est laborum.`;
  selectItems = ["option 1", "option 2", "option 3", "option 4"];
}
